import { ReactComponent as ArrowLeftIcon } from '../../../../assets/icons/arrow-left.svg';
import type { IBreadcrumbsProps } from '../../../interfaces/globals';

import './Breadcrumbs.scss';

const Breadcrumbs = ({ items }: IBreadcrumbsProps) => {
  const [first, ...rest] = items;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb navigation">
      <div className="breadcrumbs__list">
        {first.onClick ? (
          <button
            type="button"
            className="breadcrumbs__back"
            onClick={first.onClick}
            aria-label={`Go back to ${first.label}`}
          >
            <ArrowLeftIcon className="breadcrumbs__icon" aria-hidden="true" />
            <span>{first.label}</span>
          </button>
        ) : (
          <span className={rest.length === 0 ? 'breadcrumbs__current' : 'breadcrumbs__item'}>{first.label}</span>
        )}

        {rest.map((item, index) => {
          const isLast = index === rest.length - 1;
          return (
            <span key={item.label} className="breadcrumbs__segment">
              <span className="breadcrumbs__separator" aria-hidden="true">
                /
              </span>
              {item.onClick ? (
                <button type="button" className="breadcrumbs__link" onClick={item.onClick}>
                  {item.label}
                </button>
              ) : (
                <span className={isLast ? 'breadcrumbs__current' : 'breadcrumbs__item'}>{item.label}</span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
